import classNames from "classnames";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export default function ActorStateAddAttachmentButton(props: {
  label: string;
  icon?: JSX.Element;
  disabled?: boolean;
  variant?: "viewport" | "compact" | "dashed";
  "data-testid"?: string;
}) {
  const {
    label,
    icon,
    disabled = false,
    variant = "viewport",
    "data-testid": testId,
  } = { ...props };
  const isDashed = variant === "dashed";

  return (
    <div
      data-testid={testId}
      className={classNames(
        "flex w-full items-stretch overflow-hidden border-[2px] text-[14px]",
        {
          "border-solid font-medium": !isDashed,
          "border-dashed font-semibold": isDashed,
          "min-h-[38px] rounded-[8px]": variant === "viewport",
          "min-h-[40px] rounded-[10px]": isDashed,
          "rounded-full": variant === "compact",
          "border-creator-primary": !disabled,
          "bg-creator-primary text-white": !disabled && !isDashed,
          "bg-transparent text-creator-primary": !disabled && isDashed,
          "cursor-pointer": !disabled,
          "hover:bg-creator-primary-hover": !disabled && !isDashed,
          "hover:bg-creator-primary-washed": !disabled && isDashed,
          "border-interaction-disabled bg-creator-primary-background text-interaction-disabled":
            disabled,
          "cursor-not-allowed": disabled,
        }
      )}
    >
      <div
        className={classNames("flex flex-1 items-center gap-[8px]", {
          "px-[12px] py-[7px]": variant === "viewport",
          "px-[14px] py-[10px]": variant === "compact",
          "justify-center px-[12px] py-[8px]": isDashed,
        })}
      >
        {icon && <div className="text-[17px]">{icon}</div>}
        <div className="truncate">{label}</div>
      </div>
      <div
        className={classNames(
          "flex items-center justify-center px-[10px]",
          {
            "border-l-[2px] border-solid border-white/30":
              variant === "compact" && !disabled,
            "border-l-[2px] border-solid border-interaction-disabled":
              variant === "compact" && disabled,
            "opacity-70": isDashed,
          }
        )}
      >
        <KeyboardArrowDownIcon fontSize="inherit" color="inherit" />
      </div>
    </div>
  );
}
